export default __webpack_public_path__ + "static/media/brand-box.3b8fa23b.svg";